import * as React from 'react';
import { cn } from '@/lib/utils';

// Sprint 38 — Contractual Precision section header inside the NavRail.
// Caps label, tracked, separator-thin rule below, no chevrons.

interface NavSectionProps {
  label: string;
  collapsed?: boolean;
  children: React.ReactNode;
}

export function NavSection({ label, collapsed, children }: NavSectionProps) {
  return (
    <div className="mt-5 first:mt-3">
      {!collapsed && (
        <p
          className={cn(
            'px-4 pb-1.5 text-[10px] font-bold uppercase tracking-[0.12em] text-foreground-soft/70',
            'border-b-[1.5px] border-border-subtle/40 mx-1',
          )}
        >
          {label}
        </p>
      )}
      <div className="mt-1 space-y-px">{children}</div>
    </div>
  );
}
